// @flow

export default function roundNumber(num: number, scale: number): number {
  if (!("" + num).includes("e")) {
    // $FlowFixMe
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    var arr = ("" + num).split("e");
    var sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +// $FlowFixMe
    (Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
  }
}
